(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name trainingPrograms.service:TrainingAssignCrew
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .service('TrainingAssignCrewModel', TrainingAssignCrew);

    function TrainingAssignCrew(rx,RemoteService) {
        var self = this;

        /**
         * Exposed Observables
         * @type {rx.ReplaySubject}
         */
        self.selectedTraining = new rx.ReplaySubject();
        self.trainingDetails = new rx.Subject();
        self.crewTypes = new rx.ReplaySubject();
        self.crewList = new rx.Subject();
        self.crewIds = new rx.ReplaySubject();
        self.trainerTypes = new rx.ReplaySubject();
        self.crewBatchTypes = new rx.ReplaySubject();
        self.assignedTrainerDetail = new rx.ReplaySubject();
        self.assignedTrainers = new rx.ReplaySubject();
        self.assignedTraineeDetail = new rx.ReplaySubject();

        /**
         * update crewTypes stream
         * @param crewTypes
         */
        self.setCrewTypes = function (crewTypes) {
            self.crewTypes.onNext(crewTypes || []);
        };

        /**
         * update crewList Stream with search response
         * @param crewList
         */
        self.setCrewList = function (crewList) {
            self.crewList.onNext( crewList || []);
        };

        /**
         * update Trainer Types Stream
         * @param trainerTypes
         */
        self.setTrainerTypes = function (trainerTypes) {
            self.trainerTypes.onNext(trainerTypes || []);
        };

        /**
        * update Crew Batch Types Stream
          * @param crewBatchTypes
          */
          self.setCrewBatchTypes = function (crewBatchTypes) {
            self.crewBatchTypes.onNext(crewBatchTypes || []);
          };

      /**
       * update Crew Ids Stream
       * @param crewIds
       */
      self.setCrewIds = function (crewIds) {
        self.crewIds.onNext(crewIds || []);
      };

        /**
         * Update Selected Training Stream
         * @param training
         */
        self.setSelectedTraining = function (selectedTraining) {
            self.selectedTraining.onNext(selectedTraining || null);
        };

        /**
         * update AssignedTrainer Details Stream
         * @param assignedTrainerDetail
         */
        self.setAssignedTrainerDetail = function (assignedTrainerDetail) {
            self.assignedTrainerDetail.onNext(assignedTrainerDetail || null);
        };

        self.setAssignedTrainers = function (assignedTrainers) {
            self.assignedTrainers.onNext(assignedTrainers || null);
        };

        /**
         * update Assigned Trainee details stream
         * @param assignedTraineeDetail
         */
        self.setAssignedTraineeDetail = function (assignedTraineeDetail) {
            self.assignedTraineeDetail.onNext(assignedTraineeDetail || null);
        };

        /**
         * Update training details stream
         * @param trainingDetails
         */
        self.setTrainingDetails = function (trainingDetails) {
            self.trainingDetails.onNext(trainingDetails);
        };
    }

}());
